export const districts = [
  { id: 1, district: "District 1", money: 10000, },
  { id: 2, district: "District 2", money: 22000, },
  { id: 3, district: "District 3", money: 10000, },
  { id: 4, district: "District 4", money: 22000, },
  { id: 5, district: "District 5", money: 10000, },
  { id: 6, district: "District 6", money: 15000, },
  { id: 7, district: "District 7", money: 22000, },
  { id: 8, district: "District 8", money: 22000, },
  { id: 9, district: "District 9", money: 22000, },
  { id: 10, district: "District 10", money: 0, },
  { id: 11, district: "District 11", money: 10000, },
  { id: 12, district: "District 12", money: 22000, },
  { id: 13, district: "Binh Tan", money: 22000, },
  { id: 14, district: "Binh Thanh", money: 15000, },
  { id: 15, district: "Go Vap", money: 15000, },
  { id: 16, district: "Phu Nhuan", money: 10000, },
  { id: 17, district: "Tan Binh", money: 10000, },
  { id: 18, district: "Tan Phu", money: 15000, },
  { id: 19, district: "Thu Duc", money: 22000, },
];

export const categories = [
  {
    id: 1,
    catogory: "Drink",
    product: [
      {
        id: 1,
        name: "Milk Tea",
        urlParamName: "milktea",
      },
      {
        id: 2,
        name: "Coffee",
        urlParamName: "coffee",
      },
      {
        id: 3,
        name: "Latte",
        urlParamName: "latte",
      },
      {
        id: 4,
        name: "Juices",
        urlParamName: "juices",
      },
      {
        id: 5,
        name: "Smoothie",
        urlParamName: "smoothie",
      },
    ],
  },
  {
    id: 2,
    catogory: "Dessert",
    product: [
      {
        id: 1,
        name: 'Ice Creams',
        urlParamName: 'ice Creams',
      },
      {
        id: 2,
        name: 'Cakes',
        urlParamName: 'cakes',
      },
    ],
  },
];